import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector:    'app-sales-leaderboard-page',
  templateUrl: './sales-leaderboard-page.component.html',
  styleUrls:   ['./sales-leaderboard-page.component.scss']
})
export class SalesLeaderboardPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
